import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { cloneElement, Children, Component } from 'react';
import { KeyboardModeContext } from '../../../components/AppProvider/KeyboardModeProvider';
import { warnIfFragment } from '../../utils/warnIfFragment/warnIfFragment';
import { Layer } from '../Layer/Layer';
import { jsx as _jsx } from "react/jsx-runtime";
// Based on https://github.com/twbs/bootstrap/blob/v3.3.6/dist/js/bootstrap.js
function measureScrollbar() {
  const scrollDiv = document.createElement('div');
  scrollDiv.className = 'FullScreen-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
export class FullScreen extends Component {
  constructor(props) {
    super(props);
    this.handleCloseComplete = () => {
      const {
        isKeyboardMode
      } = this.context;
      if (this._lastFocus) {
        if (isKeyboardMode) {
          this._lastFocus.focus();
        }
        this._lastFocus = null;
      }
      if (FullScreen.layerCount === 0) {
        this.restoreBackgroundScrolling();
      }
    };
    this._lastFocus = document.activeElement;
  }
  componentDidMount() {
    FullScreen.layerCount += 1;
    if (FullScreen.layerCount === 1) {
      this.disableBackgroundScrolling();
    }
  }
  componentWillUnmount() {
    FullScreen.layerCount -= 1;
  }
  disableBackgroundScrolling() {
    this.addFauxScrollbar();
    [document.documentElement, document.body].forEach(el => el.classList && el.classList.add(FullScreen.NO_SCROLL_CLASS));
  }
  restoreBackgroundScrolling() {
    this.removeFauxScrollbar();
    [document.documentElement, document.body].forEach(el => el.classList && el.classList.remove(FullScreen.NO_SCROLL_CLASS));
  }
  addFauxScrollbar() {
    const bodyHasScrollbar = document.body.clientWidth < window.innerWidth;
    if (bodyHasScrollbar) {
      // To avoid changing the body width when we disable scrollbar, we replace
      // the scrollbar with padding of equal width.
      const computedStyle = window.getComputedStyle(document.body);
      const originalBodyPaddingRight = computedStyle.paddingRight;
      const originalBodyPaddingRightNumber = parseFloat(originalBodyPaddingRight);
      FullScreen.originalBodyPaddingRight = originalBodyPaddingRight;
      document.body.style.paddingRight = `${measureScrollbar() + originalBodyPaddingRightNumber}px`;
    }
  }
  removeFauxScrollbar() {
    document.body.style.paddingRight = FullScreen.originalBodyPaddingRight;
  }
  render() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    warnIfFragment(children, 'FullScreen');
    return /*#__PURE__*/_jsx(Layer, Object.assign({}, rest, {
      onCloseComplete: this.handleCloseComplete,
      children: /*#__PURE__*/cloneElement(Children.only(children), {
        open: true
      })
    }));
  }
}
FullScreen.layerCount = 0;
FullScreen.NO_SCROLL_CLASS = 'FullScreenBackground';
FullScreen.originalBodyPaddingRight = '';
FullScreen.contextType = KeyboardModeContext;